import React from "react";
import { Link } from "react-router-dom";
import Announcement from "../components/Announcement";
import FixMenu from "../components/FixMenu";
import Header from "../components/Header";

const FPPCAS = () => {
  return (
    <>
      <div id="bodyaddid">
        <Header />
        <FixMenu />
        <section className="main-banner">
          <div
            className="innerpagebanner"
            style={{
              backgroundImage:
                "url(" + "assets/img/inner/cost-data-book.jpg" + ")",
              backgroundSize: "100% auto",
            }}
          ></div>
          <Announcement />
        </section>
        <section className="main_sectiods">
          <div className="container main_bdy">
            <div className="row justify-content-center">
              <div className="col-sm-12">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="#">Home </Link>
                    <span className="icondsds">
                      <i className="fa fa-chevron-right" aria-hidden="true"></i>
                    </span>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to="/Fuel-and-Power-Purchase-Cost-Adjustment" className="active">
                      Fuel and Power Purchase Adjustment Surcharge (FPPAS)
                    </Link>
                  </li>
                </ol>
              </div>
            </div>
            <div className="row justify-content-center padtops">
              <div className="row">
                <div className="col-sm-12 bg_cols">
                  <div className="form_div">

                    <div className="tab-content tab_main">


                      <div className="tab-pane fade show active" id="login2">
                        <div className="row">
                          <div className="col-md-12">
                            <div className="companysection">
                              <legend>Fuel and Power Purchase Adjustment Surcharge (FPPAS)</legend>
                              <hr />
                              <div className="row">
                                <div className="col-md-6" >
                                  <li className="d-flex align-items-start">
                                    <img src="assets/img/pdf.png" alt="" style={{ marginRight: '10px' }} />
                                    <a
                                      href="https://iwebapps.noidapower.com:8032/download/FPPAS/Gazette Notification UPERC (MYT for Distribution and Transmission Tariff) (Third Amendment) Regulations, 2025.pdf"
                                      target="_blank"
                                      rel="noreferrer"
                                    >
                                      Gazette Notification UPERC (MYT for Distribution and Transmission Tariff) (Third Amendment) Regulations, 2025
                                    </a>
                                  </li>
                                </div>

                                <div className="col-md-6">
                                  <li className="d-flex align-items-start">
                                    <img src="assets/img/pdf.png" alt="" style={{ marginRight: '10px' }} />
                                    <a
                                      href="https://iwebapps.noidapower.com:8032/download/FPPAS/FAQ%20-%20FPPAS.pdf"
                                      target="_blank"
                                      rel="noreferrer"
                                    >
                                      FAQ FPPAS
                                    </a>
                                  </li>
                                </div>

                                <div className="col-md-12 mt-3">
                                  <li className="d-flex align-items-start">
                                    <img src="assets/img/pdf.png" alt="" style={{ marginRight: '10px' }} />
                                    <a
                                      href="https://iwebapps.noidapower.com:8032/download/FPPAS/FPPAS%20Calculation%20for%20April%E2%80%992025.pdf"
                                      target="_blank"
                                      rel="noreferrer"
                                    >
                                      FPPAS Calculation for April'25
                                    </a>
                                  </li>
                                </div>
                                <div className="col-md-12 mt-3">
                                  <li className="d-flex align-items-start">
                                    <img src="assets/img/pdf.png" alt="" style={{ marginRight: '10px' }} />
                                    <a
                                      href="https://iwebapps.noidapower.com:8032/download/FPPAS/FPPAS Calculation for May'25.pdf"
                                      target="_blank"
                                      rel="noreferrer"
                                    >
                                      FPPAS Calculation for May'25
                                    </a>
                                  </li>
                                </div>
                                <div className="col-md-12 mt-3">
                                  <li className="d-flex align-items-start">
                                    <img src="assets/img/pdf.png" alt="" style={{ marginRight: '10px' }} />
                                    <a
                                      href="https://iwebapps.noidapower.com:8032/download/FPPAS/FPPAS Calculation for June'25.pdf"
                                      target="_blank"
                                      rel="noreferrer"
                                    >
                                      FPPAS Calculation for June'25
                                    </a>
                                  </li>
                                </div>
                                <div className="col-md-12 mt-3">
                                  <li className="d-flex align-items-start">
                                    <img src="assets/img/pdf.png" alt="" style={{ marginRight: '10px' }} />
                                    <a
                                      href="https://iwebapps.noidapower.com:8032/download/FPPAS/FPPAS Calculation for July'25.pdf"
                                      target="_blank"
                                      rel="noreferrer"
                                    >
                                      FPPAS Calculation for July'25
                                    </a>
                                  </li>
                                </div>
                                <div className="col-md-12 mt-3">
                                  <li className="d-flex align-items-start">
                                    <img src="assets/img/pdf.png" alt="" style={{ marginRight: '10px' }} />
                                    <a
                                      href="https://iwebapps.noidapower.com:8032/download/FPPAS/FPPAS_Calculation_for_Aug_25.pdf"
                                      target="_blank"
                                      rel="noreferrer"
                                    >
                                      FPPAS Calculation for Aug'25
                                    </a>
                                  </li>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default FPPCAS;
